import { observer } from "mobx-react-lite"
import React, { useContext, useState } from 'react'
import { toastError, toastSuccess } from "../../FormComponents/Toasts"
import Modal from "../../Modal/Modal"
import axiosService from "../../../utils/AxiosService"
import { BrowseContext } from "../../../contexts/BrowseContext"
import Input from '../../FormComponents/Input'

export default observer(function DeleteClientModal({ isOpen, setOpenDeleteModal, client }) {
const { browseState, selectedClient, clients } = useContext(BrowseContext)
const [clientName, setClientName] = useState('')

const deleteClient = () => {
  axiosService.delete(`/api/project_manager/clients/${selectedClient.id}`)
    .then((removedClient) => {
      browseState.clients = clients.filter(client => +client.id !== +removedClient.id)
      toastSuccess(`Client ${removedClient.name} has been deleted!`)
      browseState.toggleDeleteClient()
    }).catch(error => toastError(error))
}

  return (
    <Modal isOpen={browseState.openDeleteClient} onClose={() => browseState.toggleDeleteClient()}>
      <Modal.Header>Delete Client</Modal.Header>
      <Modal.Body>
        <div className="w-[400px]">
          <p className="mb-3"><strong>Warning:</strong> Deleting this client "{selectedClient.name}" will result in the permanent
          loss of all associated folders and campaigns. To confirm deletion, please enter
          the client's name in the field below and click the "Delete" button.</p>
          <Input
            noLabelPadding
            label='Confirm client name'
            onChange={e => setClientName(e.target.value)}
          />

          <div className="flex justify-between mt-5">
            <button
              type='button'
              className='rb-btn-cancel font-bold text-md ml p-2 px-4 rounded-lg'
              onClick={() => browseState.toggleDeleteClient()}
            >
              Cancel
            </button>
            <button
              type="button"
              className={`${clientName !== selectedClient.name ? 'opacity-25' : ''} ml-auto bg-red-500 text-white rounded-lg p-2 px-4 submit text-center`}
              disabled={clientName !== selectedClient.name}
              onClick={() => deleteClient()}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
})
